/** Copy shown when AI prefills guided-flow form fields (banner + parsed-input hint). */
export const sharedStaticDefaults = {
  operatorAiPrefillBanner:
    'AI selected and prefilled fields using your input. Feel free to change anything if needed.',
  operatorPasswordPrefillHint:
    "Got it. I've filled the form from your message, except the password. Add it below, then review and confirm. (I don't take passwords from chat.)",
  operatorPartialPrefillHint:
    "Got it. I've selected and filled the form from your message. A few fields still need input on the form, complete those, then continue and confirm when you're ready.",
} as const;
